module.exports = __webpack_public_path__ + "static/media/pdf_icon.61bb288a.svg";